export const quiz_question_number = 5;
export const COUNTDOWN_MESSAGE_ANSWER = "question_answered";
